<template>
  <a class="oap-header__logo-link" href="/">
    <h1 v-if="isRenderH1HomePage" class="is-sr-only">{{ h1HomePageTitle }}</h1>
    <img :src="logoSrc" :alt="logoAlt" class="oap-header__logo-image" />
  </a>
</template>

<script>
export default {
  name: 'HeaderLogo',
  props: {
    logo: { type: String, default: '' },
    alt: { type: String, default: 'Loreal Paris' },

    mexLogo: { type: String, default: '' },
    mexLogoAlt: { type: String, default: 'Loreal Paris' },

    colorsonicLogo: { type: String, default: '' },
    colorsonicLogoAlt: { type: String, default: 'Colorsonic' },

    bmagLogo: { type: String, default: '' },
    bmagLogoAlt: { type: String, default: 'Beauty Magazine' },
    h1HomePageTitle: { type: String, default: 'Loreal Paris homepage' }
  },
  data() {
    return {
      logoSrc: '',
      logoAlt: '',
      isRenderH1HomePage: false
    };
  },
  mounted() {
    const mexCSSClass = document.body.classList.contains('MEX-ff6600');
    const colorsonicCSSClass = document.body.classList.contains('colorsonic-page');
    const bmagCSSClass = document.body.classList.contains('oap-bmag-page');

    if (mexCSSClass) {
      this.logoSrc = this.mexLogo;
      this.logoAlt = this.mexLogoAlt;
    } else if (colorsonicCSSClass) {
      this.logoSrc = this.colorsonicLogo;
      this.logoAlt = this.colorsonicLogoAlt;
    } else if (bmagCSSClass && this.bmagLogo) {
      this.logoSrc = this.bmagLogo;
      this.logoAlt = this.bmagLogoAlt;
    } else {
      this.logoSrc = this.logo;
      this.logoAlt = this.alt;
    }

    if (window.location && window.location.hash) {
      let doc = document;
      const imageLoad = doc.querySelectorAll('.lazyload');
      imageLoad.forEach((element) => {
        window.lazySizes.loader.unveil(element);
      });
      let element = doc.querySelector(window.location.hash);
      let headerOffset = 75;
      if (element) {
        setTimeout(function () {
          let elementPosition = element.getBoundingClientRect().top;
          let offsetPosition = elementPosition + window.scrollY - headerOffset;
          window.scrollTo(0, offsetPosition);
        }, 300);
      }
    }

    this.detectH1Homepage();
  },
  methods: {
    detectH1Homepage() {
      const isHomePage = document.querySelector(".homeWrapper");
      if (!isHomePage) return;

      const hasH1 = document.querySelector("h1");
      if (hasH1) return;

      this.isRenderH1HomePage = true;
    }
  }
};
</script>
